import type { Location } from "vue-router";
import { MenuItem } from "@/app/ui/navigation/types";
import { dutySchemeType } from "@/components/pages/duty/composables/dutyConfiguration";
import type Guid from "@/app/types/common/guid";
import { LocalDate } from "@js-joda/core";
import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";

export const dutyMenuSouthAfrican = {
  root: "navigation_duty_group_south_african",
  dutyReturnList: "south_african_duty_returns_list",
  dutyReturnListLocation: (): Location => ({
    name: dutyMenuSouthAfrican.dutyReturnList,
  }),
  editReturn: "south_african_duty_edit_return",
  editReturnLocation: (id: Guid, isEditing: boolean): Location => ({
    name: dutyMenuSouthAfrican.editReturn,
    params: {
      id: id.toString(),
      mode: isEditing ? "edit" : "view",
    },
  }),
  createReturn: "south_african_duty_create_return",
  createReturnLocation: (): Location => ({
    name: dutyMenuSouthAfrican.createReturn,
  }),
  audit: "south_african_duty_audit_report",
  viewAudit: (fromDate: LocalDate, toDate: LocalDate): Location => ({
    name: dutyMenuSouthAfrican.audit,
    params: {
      fromDateInclusive: fromDate.toString(),
      toDateInclusive: toDate.toString(),
    },
  }),
};

export const buildDutyMenuSouthAfricanItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    name: dutyMenuSouthAfrican.root,
    icon: "Assignment",
    visible: () =>
      dutySchemeType.value.isSouthAfrica() &&
      hasPermissionsUsingUserStore([EnumUserPermission.menuDutyView]),
    subMenus: [
      MenuItem.fromOpts({
        name: dutyMenuSouthAfrican.dutyReturnList,
        url: "/duty/southafrica/list",
        breadcrumbParentName: dutyMenuSouthAfrican.root,
        view: () =>
          import(
            /* webpackChunkName: "south-african-duty" */ "@/components/pages/duty/south_african/ListSouthAfricanDutyReturns.vue"
          ),
      }),
      MenuItem.fromOpts({
        name: dutyMenuSouthAfrican.editReturn,
        url: "/duty/southafrica/:id/:mode",
        breadcrumbParentName: dutyMenuSouthAfrican.dutyReturnList,
        view: () =>
          import(
            /* webpackChunkName: "south-african-duty" */ "@/components/pages/duty/south_african/EditSouthAfricanDutyReturn.vue"
          ),
        visible: false,
        componentProps: (route) => {
          return {
            id: route.params.id,
            editing:
              route.params.id &&
              route.params.mode.toLowerCase().trim() === "edit",
          };
        },
      }),
      MenuItem.fromOpts({
        name: dutyMenuSouthAfrican.createReturn,
        url: "/duty/southafrica/create",
        breadcrumbParentName: dutyMenuSouthAfrican.dutyReturnList,
        view: () =>
          import(
            /* webpackChunkName: "south-african-duty" */ "@/components/pages/duty/south_african/EditSouthAfricanDutyReturn.vue"
          ),
        visible: false,
        componentProps: (route) => ({
          editing: true,
        }),
      }),
      MenuItem.fromOpts({
        name: dutyMenuSouthAfrican.audit,
        url: "/duty/southafrica/audit",
        componentProps: (r) => ({
          fromDateInclusive:
            r.params.fromDateInclusive &&
            LocalDate.parse(r.params.fromDateInclusive),
          toDateInclusive:
            r.params.toDateInclusive &&
            LocalDate.parse(r.params.toDateInclusive),
        }),
        view: () =>
          import("@/components/pages/duty/south_african/SouthAfricanDutyAudit.vue"),
      }),
    ],
  }),
];
